import Tippy from "@tippyjs/react"

/**
 * CustomTooltip component wraps the NextUI Tooltip component with additional styling.
 *
 * @param {Object} props - The properties object.
 * @param {React.ReactNode} props.children - The content that will trigger the tooltip.
 * @param {string} props.content - The content to be displayed inside the tooltip.
 * @param {string} [props.placement="bottom-left"] - The placement of the tooltip relative to the children.
 * @param {number} [props.delay=0] - The delay in milliseconds before the tooltip is shown.
 *
 * @returns {JSX.Element} The CustomTooltip component.
 */
export const CustomTooltip = ({ children, content, placement = "top", delay = 0, ...props }) => {
    return (
        <Tippy
            placement={placement}
            content={
                <div className="rounded-xl bg-primaryBg px-3 py-1 text-sm text-white">
                    {content}
                </div>
            }
            delay={delay}

            {...props}
        >
            {children}
        </Tippy>
    )
}